import yousersjs from '@yola/yousersjs';

const verifyConfirmationToken = (options) => yousersjs.requests.verifyConfirmationToken(options);

export default verifyConfirmationToken;
